import * as yup from 'yup'

/**
 * Shape-only, and deliberately so. All eleven fields are `@IsOptional()` on both backend DTOs,
 * so there is no required field to enforce.
 *
 * The one cross-field rule that exists — wire transfers being "required" when the customer runs
 * Payments — is rendered as a warning rather than a validation error: rows written by Retool may
 * already sit in that state, and blocking Save would strand unrelated edits.
 *
 * The two constraints that could actually fail a save (`@IsUUID()` on an unselected template,
 * and `undefined` silently not clearing a column) are handled in the mapper, because they are
 * payload-shape concerns the admin can neither see nor fix from the form.
 */
export const customerSettingsValidator = yup.object({
  onboardingSuccessScreenTitle: yup.string(),
  onboardingSuccessScreenDescription: yup.string(),
  onboardingDelayedStepTitle: yup.string(),
  onboardingDelayedStepDescription: yup.string(),
  onboardingSuccessScreenDelayedTitle: yup.string(),
  onboardingSuccessScreenDelayedDescription: yup.string(),
  loanTransferEnabled: yup.boolean(),
  wireTransferEnabled: yup.boolean(),
  masterContractorDocusignTemplateId: yup.string(),
  internalDocumentReviewInstructions: yup.string(),
})
